/**
 * @file ContentContext.js
 * @description 콘텐츠 값 맵을 전달하는 컨텍스트입니다.
 * @used-in content/ContentProvider.jsx, content/useContent.js
 */

import { createContext } from 'react';

// [기술] null로 Provider 부재를 구분하며 별도 모듈로 분리해 순환 참조를 피합니다.
export const ContentContext = createContext(null);
